<ng-container *ngIf="layout === ProductLayout.Grid">
    <div
        [attr.title]="item.name"
        class="group relative rounded-lg h-full flex flex-col justify-between bg-white"
        role="button"
        (click)="onProductClick()"
        [class.opacity-25]="!item.available || quantityInStock === 0"
    >
        <div class="aspect-square w-full overflow-hidden rounded-lg bg-gray-100 group-hover:opacity-75 flex-none">
            <img
                [ngSrc]="item.photos[0] || DEFAULT_IMAGE"
                [attr.alt]="item.name"
                loading="lazy"
                height="172"
                width="172"
                class="h-full w-full object-cover object-center group-hover:opacity-75"
            />
        </div>

        <div class="mt-4 flex-auto flex flex-col gap-1 justify-end px-2 pb-2">
            <p class="text-xs text-blue-400" *ngIf="quantityInStock > 0 && item.available">
                {{ 'only_n_product_left' | transloco : { value: quantityInStock } }}
            </p>
            <h3 class="text-sm text-gray-700">
                <span>{{ item.name }}</span>
                <span *ngIf="!item.available || quantityInStock === 0" class="text-red-500">
                    ({{ 'sold' | transloco }})
                </span>
            </h3>
            <p class="text-base">
                <button
                    appearance="secondary-destructive"
                    tuiButton
                    icon="svg::coupon"
                    size="s"
                    style="font-size: 0.75rem"
                    (click)="$event.preventDefault(); $event.stopPropagation()"
                    *ngIf="item.discount_percent || item.discount_price"
                >
                    {{
                        item.discount_percent
                            ? item.discount_percent + '%'
                            : '-' + (item.discount_price | formatCurrency)
                    }}
                </button>
                <span
                    class="text-gray-400 line-through"
                    style="position: relative; top: 0.3rem; font-size: 0.75rem"
                    *ngIf="item.product_price && item.product_price > item.price"
                >
                    {{ item.product_price | formatCurrency }}
                </span>
                <span class="font-medium text-gray-900 block">{{ item.price | formatCurrency }}</span>
            </p>

            <!-- <ng-container *ngIf="IS_FNB_APP"> -->
            <!-- <ng-container *tuiLet="selectedQuantity$ | async as selectedQuantity">
                <ng-container *ngIf="selectedQuantity; else addToCartBlockTpl">
                    <us-number-group
                        [value]="selectedQuantity"
                        (decreaseQuantityClick)="decreaseQuantity()"
                        (increaseQuantityClick)="increaseQuantity()"
                        [minimumQuantity]="minimumQuantity"
                        [maximumQuantity]="maximumQuantity + selectedQuantity"
                    >
                    </us-number-group>
                </ng-container>
            </ng-container>

            <ng-template #addToCartBlockTpl>
                <button tuiButton type="button" size="s" appearance="secondary" (click)="addToCart($event)">
                    {{ (item.units.length > 1 ? 'choose' : 'add') | transloco }}
                </button>
            </ng-template> -->
            <!-- </ng-container> -->

            <!--<div class='flex item-center justify-between'>
                <button
                    type='button'
                    tuiIconButton
                    (click)='addToCart($event)'
                    icon='svg::plus'
                    shape='rounded'
                    size='s'
                    [disabled]='!item.available'
                ></button>
            </div>-->
        </div>

        <span
            class="badge badge-red absolute top-0 left-0"
            *ngIf="item.discount_percent !== null && item.discount_percent > 0"
        >
            {{ '-' + item.discount_percent + '%' }}
        </span>
    </div>
</ng-container>
<ng-container *ngIf="layout === ProductLayout.List">
    <div class="flex group relative" (click)="onProductClick()">
        <div class="h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-gray-200">
            <img
                [ngSrc]="item.photos[0] || DEFAULT_IMAGE"
                [attr.alt]="item.name"
                loading="lazy"
                height="94"
                width="94"
                class="h-full w-full object-cover object-center"
            />
        </div>

        <div class="ml-4 flex-auto flex flex-col justify-between">
            <div class="flex-auto">
                <h3 class="text-base text-gray-700 font-medium">
                    <span>{{ item.name }}</span>
                    <span *ngIf="!item.available || quantityInStock === 0" class="text-red-400 text-sm">
                        ({{ 'sold' | transloco }})
                    </span>
                </h3>
                <p class="text-sm text-blue-400" *ngIf="quantityInStock > 0 && item.available">
                    {{ 'only_n_product_left' | transloco : { value: quantityInStock } }}
                </p>
            </div>

            <div class="flex-none flex justify-between">
                <p class="mt-1 text-base">
                    <span class="text-gray-900">{{ item.price | formatCurrency }}</span>
                    <span
                        class="text-gray-500 line-through ml-1"
                        *ngIf="item.old_price !== null && item.old_price > item.price"
                    >
                        {{ item.old_price | formatCurrency }}
                    </span>
                </p>

                <!-- <ng-container *tuiLet="selectedQuantity$ | async as selectedQuantity">
                    <ng-container *ngIf="selectedQuantity; else addToCartTpl">
                        <us-number-group
                            [value]="selectedQuantity"
                            (decreaseQuantityClick)="decreaseQuantity()"
                            (increaseQuantityClick)="increaseQuantity()"
                            [minimumQuantity]="minimumQuantity"
                            [maximumQuantity]="maximumQuantity + selectedQuantity"
                        >
                        </us-number-group>
                    </ng-container>
                </ng-container>

                <ng-template #addToCartTpl>
                    <button
                        tuiIconButton
                        type="button"
                        size="s"
                        icon="svg::plus"
                        shape="rounded"
                        (click)="addToCart($event)"
                    ></button>
                </ng-template> -->
            </div>
        </div>

        <!--<div class="ml-4 flex flex-1 justify-between">
            <div>
                <h3 class="text-base text-gray-700 font-medium">
                    <span>{{ item.name }}</span>
                    <span *ngIf="!item.available || quantityInStock === 0" class="text-red-500">
                        ({{ 'sold' | transloco }})
                    </span>
                </h3>
                <p class="text-sm text-blue-400" *ngIf="quantityInStock > 0 && item.available">
                    {{ 'only_n_product_left' | transloco: { value: quantityInStock } }}
                </p>

                <p class="mt-1 text-base">
                    <span class="text-gray-900">{{ item.price | formatCurrency }}</span>
                    <span
                        class="text-gray-500 line-through ml-1"
                        *ngIf="item.old_price !== null && item.old_price > item.price"
                    >
                        {{ item.old_price | formatCurrency }}
                    </span>
                </p>
            </div>
            <div class="flex flex-col justify-center">
                <button
                    tuiIconButton
                    type="button"
                    size="s"
                    icon="svg::plus"
                    shape="rounded"
                    (click)="addToCart($event)"
                ></button>
            </div>
        </div>-->

        <span
            class="badge badge-red absolute top-0 left-0"
            *ngIf="item.discount_percent !== null && item.discount_percent > 0"
        >
            {{ '-' + item.discount_percent + '%' }}
        </span>
    </div>
</ng-container>
